import { Dialog, TextField } from "@episerver/ui-framework";
import { useFormik } from "formik";
import * as Yup from "yup";
import React from "react";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { useParams } from "react-router-dom";
import { fetchEnumsByType, updateEnum } from "../reducers/asyncThunks";
import {
    formSelector,
    initialEnumFormState,
    onChangeName,
    onChangeType,
    onOpenDialog,
} from "../reducers/enumFormReducer";
import { EnumData } from "../model/Enum";

const EnumForm = () => {
    const dispatch = useAppDispatch();
    const { type } = useParams<{ type: string }>();
    const { open, title, enumData } = useAppSelector(formSelector);

    useEffect(() => {
        if (type) {
            dispatch(onChangeType(type));
        }
    }, [type]);

    const { values, isValid, errors, handleSubmit, setFieldValue, validateForm } = useFormik({
        enableReinitialize: true,
        initialValues: enumData,
        validationSchema: Yup.object({
            name: Yup.string().trim().required("*Required"),
        }),
        onSubmit: async (enumData: EnumData) => {
            dispatch(onOpenDialog(initialEnumFormState));
            await dispatch(updateEnum(enumData));
            dispatch(fetchEnumsByType(enumData.type));
        },
    });

    const onChangeTextField = (e: any) => {
        e.persist();
        let { name, value } = e.target;
        setFieldValue(name, value);
        dispatch(onChangeName(value));
    };

    useEffect(() => {
        validateForm();
    }, [values]);

    return (
        <Dialog
            open={open}
            title={title}
            dismissLabel="Cancel"
            confirmLabel="Save"
            enableConfirm={isValid}
            onInteraction={async (e) => {
                if (e.detail.action === "confirm") {
                    handleSubmit();
                } else {
                    dispatch(onOpenDialog(initialEnumFormState));
                }
            }}
        >
            <React.Fragment>
                <br />
                <TextField
                    outlined
                    maxLength={255}
                    label="Name"
                    name="Name"
                    helperText={errors.name ?? ""}
                    value={values.name ?? ""}
                    onChange={onChangeTextField}
                />
            </React.Fragment>
        </Dialog>
    );
};

export default EnumForm;
